import React from 'react';
import { Card, Typography } from 'antd';
import {useTranslations} from '../../lang';
import LegalDocument from '../../Components/LegalDocument';
import legalDocuments from '../../legal/englishLegalDocuments.json';
import {getMarketForLocation} from '../../environment';

const { Title } = Typography;

export default function PrivacyPolicy() {
    useTranslations();
    const market = getMarketForLocation(window.location.hostname, window.location.search);
    if (market === 'US') {
        return <LegalDocument document={legalDocuments.privacy}/>;
    }
    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
            <Card>
                <Title level={1}>Privacybeleid</Title>

                <div className="page-body">
                    <h1 id="be0d0e57-2049-4e88-9940-bdb6e7e7a58f" className="">Privacy statement
                        Oogst.app</h1>
                    <p id="a10632c5-91f5-4f69-b995-472554fb0130" className="">Dit is het privacy statement van
                        Oogst.app. Oogst.app is ingeschreven bij de Kamer van Koophandel onder nummer 61063304 en is
                        gevestigd aan
                        Rijksstraatweg 55, 8121ED, Olst. In dit document wordt uitgelegd hoe Oogst.app omgaat met het
                        verwerken van uw
                        persoonsgegevens. Bij de verwerking van uw persoonsgegevens betracht Oogst.app de grootst
                        mogelijke
                        zorgvuldigheid.</p>
                    <h1 id="5815f53f-c4c1-4028-b8e8-a46fa7174539" className="">Verkrijging persoonsgegevens:</h1>
                    <p id="8ca84cbd-c7c8-427d-aa01-ded27d0c9af2" className="">Indien u gebruikt maakt van de diensten
                        van
                        Oogst.app,
                        verstrekt u zelf een aantal persoonsgegevens aan Oogst.app, of worden persoonsgegevens van u
                        verkregen in het
                        kader van de overeenkomst. Onder persoonsgegevens wordt verstaan alle gegevens die betrekking
                        hebben
                        op
                        geïdentificeerde of identificeerbare natuurlijke persoon.</p>
                    <h1 id="5d8fff4e-f916-446c-b911-7f9eea9fc41c" className="">Categorieën persoonsgegevens</h1>
                    <p id="cb9332b9-2e9b-4da7-9f6f-e3ab306bb9a2" className="">Oogst.app verwerkt de volgende categorieën
                        van
                        persoonsgegevens:<br/>– Contact- en NAW-gegevens;<br/>– E-mailadres;<br/>– Financiële
                        gegevens;<br/>–
                        Accountgegevens;<br/>– Overige door u zelf verstrekte persoonsgegevens.<br/></p>
                    <p id="9a0ab8be-9f5e-4c82-b679-0f10bc83a541" className="">
                    </p>
                    <h1 id="3147ad19-6be4-4e90-a8a8-1d9966ef753b" className="">Doel van de verwerking</h1>
                    <p id="befe75b9-4531-4d4d-b047-d867bdc677fa" className="">De persoonsgegevens die door Oogst.app
                        verwerkt
                        worden, hebben
                        ten doel om:<br/>– Contact met u op te nemen om u te informeren over de door u afgenomen
                        diensten en
                        de
                        uitvoering daarvan;<br/>– Het uitvoeren van haar diensten;<br/>– Het voltooien van het aanmaken
                        van
                        een account;<br/>–
                        Verbeteren van de dienstverlening;<br/>– Het verrichten van betalingen;<br/>– Nakomen van
                        wettelijke
                        verplichtingen;<br/>– Het doen van marketing en communicatieuitingen;<br/>– Verbeteren van de
                        website door
                        middel van het analyseren van bezoekersgedrag op de website;<br/>– Gegevensuitwisseling met
                        derden
                        ten behoeve
                        van de uitvoering van de dienstverlening.<br/></p>
                    <h1 id="55ae9091-2144-4bce-82c7-7eee5877a299" className="">Grondslag verwerking</h1>
                    <p id="4a03e8ce-850a-465c-9a0c-461cb45c74ab" className="">Het verwerken van persoonsgegevens is
                        slechts
                        mogelijk op
                        grond van de hiernavolgende grondslagen: (i) wettelijke verplichting, (ii) uitvoering
                        overeenkomst,
                        (iii)
                        verkregen (uitdrukkelijke) toestemming van de betrokkenen, en (iv) gerechtvaardigd belang. Bij
                        het
                        verlenen van
                        de diensten van Oogst.app worden persoonsgegevens verwerkt. Oogst.app verwerkt uitsluitend
                        gegevens
                        die
                        Oogst.app noodzakelijk acht voor (het verbeteren van) de dienstverlening en gaat zorgvuldig om
                        met
                        de
                        (persoons)gegevens die zij over u en uw gebruik van de diensten heeft verzameld. De grondslag
                        voor
                        het verwerken
                        van deze gegevens is de overeenkomst die u met Oogst.app bent aangegaan. Ook kunnen er
                        persoonsgegevens van u
                        verwerkt worden door het bezoeken van de website <a
                            href="http://www.oogst.app">www.oogst.app</a> en
                        oogst.app
                        indien u hiervoor toestemming hebt gegeven.</p>
                    <h1 id="20e3d733-c2a6-4dd1-81dd-409375e66de2" className="">Noodzaak verwerking</h1>
                    <p id="bd55b5dc-2f02-4bdc-b86d-7c7621ea79ea" className="">De verwerking van uw persoonsgegevens is
                        noodzakelijk om de
                        dienstverlening uit te kunnen voeren. De diensten die Oogst.app biedt, kunnen zonder het
                        verwerken
                        van uw
                        persoonsgegevens niet volledig uitgevoerd worden. Indien voor specifieke doeleinden met
                        betrekking
                        tot de
                        persoonsgegevens uw expliciete toestemming is vereist, dient u hiervoor separaat toestemming te
                        geven.</p>
                    <h1 id="86b584ef-973c-47ef-a594-4f7caaa09d96" className="">Geautomatiseerde besluitvorming</h1>
                    <p id="3779b790-0fb3-44b3-833d-eb427f7b9a4d" className="">Indien sprake is van enige
                        geautomatiseerde
                        besluitvorming,
                        wordt deze besluitvorming verricht door computersystemen en/of computerprogramma’s zonder
                        tussenkomst van
                        menselijk handelen. De betrokkene is zelf verantwoordelijk voor de gegevens die hij of zij
                        verstrekt
                        en die ten
                        tijde van de geautomatiseerde besluitvorming worden gebruikt. Indien de gegevens niet juist of
                        onvolledig
                        blijken te zijn, komt de schade ten gevolge hiervan voor rekening en risico van de Betrokkene.
                        Hieronder wordt
                        tevens verstaan het niet, niet tijdig of foutief uitvoeren van de overeenkomst.</p>
                    <h1 id="04fefe9b-6795-4f4b-a15a-75ecaf962c0f" className="">Bewaartermijn</h1>
                    <p id="4897b8b6-fff5-469d-82ff-28b8353c63ea" className="">De door Oogst.app verwerkte
                        persoonsgegevens
                        worden bewaard
                        conform de relevante wet- en regelgeving. Indien een langere bewaartermijn noodzakelijk is op
                        grond
                        van wet- of
                        regelgeving, worden de persoonsgegevens langer bewaard conform deze eisen. Alle (verkregen)
                        persoonsgegevens
                        worden niet langer bewaard dan strikt noodzakelijk.</p>
                    <h1 id="aef05159-bd19-43e1-9303-3d0d89ea9b92" className="">Verwerking door derden</h1>
                    <p id="7daefe9b-1ff9-4241-a1a4-2bfe62efa314" className="">Oogst.app deelt persoonsgegevens slechts
                        met
                        derden indien dit
                        strikt noodzakelijk is voor de uitvoering van een overeenkomst en om te voldoen aan relevante
                        wet-
                        en
                        regelgeving. Er worden geen persoonsgegevens verkocht. Op Oogst.app kan een wettelijke
                        verplichting
                        rusten om
                        persoonsgegevens met derden te delen. Indien met derden persoonsgegevens worden gedeeld, worden
                        hiervoor
                        verwerkersovereenkomsten gesloten. De derden waarmee persoonsgegevens gedeeld worden zijn:<br/>–
                        De
                        Payment
                        Provider, ten behoeve van de uitvoering van een overeenkomst. De categorieën van
                        persoonsgegevens
                        die verwerkt
                        worden zijn financiële gegevens.<br/>– De Boekhouder, ten behoeve van de uitvoering van een
                        overeenkomst. De
                        categorieën van persoonsgegevens die verwerkt worden zijn contact- en NAW-gegevens en financiële
                        gegevens.<br/>–
                        Softwareleveranciers, ten behoeve van de uitvoering van de overeenkomst. De categorieën van
                        persoonsgegevens die
                        verwerkt worden zijn de locatiegegevens, het e-mailadres en contact- en NAW-gegevens.<br/>–
                        Websitebeheerder,
                        ten behoeve van uitvoering van de overeenkomst. De categorieën van persoonsgegevens die verwerkt
                        worden zijn de
                        locatiegegevens, het e-mailadres en contact- en NAW-gegevens.<br/></p>
                    <h1 id="12a9c179-f116-49e5-b8dd-9e2ab25554ed" className="">Beveiliging van Persoonsgegevens</h1>
                    <p id="e3e40d2a-2f30-48ec-ae2e-5b6dedb1d8a0" className="">Oogst.app neemt het beschermen van uw
                        persoonsgegevens serieus
                        en neemt dienaangaande, rekening houdend met de stand van de techniek, uitvoeringskosten, alsook
                        met
                        de aard,
                        omvang, context en de verwerkingsdoeleinden en de qua waarschijnlijkheid en ernst uiteenlopende
                        risico’s voor de
                        rechten en vrijheden van personen, passende technische en organisatorische maatregelen om een op
                        het
                        risico
                        afgestemd beveiligingsniveau te waarborgen.</p>
                    <h1 id="3ce82bb7-717c-44e4-ab3f-4d3d47231f0f" className="">Disclaimer website</h1>
                    <p id="ebaf33ff-07c9-4e09-84bc-8d80cd8f0902" className="">Door het gebruiken van de website stemt u
                        in met
                        de
                        disclaimer. Oogst.app behoudt zich het recht voor te allen tijde de inhoud van haar website
                        en/of
                        deze
                        disclaimer te wijzigen zonder haar klanten en/of gebruikers van de website over deze wijziging
                        te
                        informeren. De
                        inhoud van de website is met de grootst mogelijke zorgvuldigheid samengesteld, maar kan
                        desondanks
                        mogelijke
                        onjuistheden bevatten of onvolledig zijn. Oogst.app aanvaardt op geen enkele wijze enig
                        aansprakelijkheid voor
                        schade
                        die is ontstaan door, of voortvloeit uit het gebruik van de website. Het gebruiken van deze
                        website
                        komt geheel
                        voor eigen rekening en risico van een gebruiker van de website. Aan de inhoud van de website
                        kunnen
                        geen rechten
                        ontleend worden. Alle teksten op de website zijn auteursrechtelijk beschermd en eigendom van
                        Oogst.app voor
                        zover deze niet aan derden toebehoren.</p>
                    <h1 id="ac2c1e35-e4f6-4143-82ce-f1d81b8261a6" className="">Cookieverklaring</h1>
                    <p id="a51be315-7938-4e12-a7d2-eccda6219472" className="">Oogst.app maakt gebruik van technische en
                        functionele cookies
                        om de website te optimaliseren. Cookies zijn kleine tekstbestanden die door het bezoek aan een
                        website worden
                        meegestuurd om gebruikerservaringen van bezoekers efficiënter te maken. Oogst.app mag, volgens
                        de
                        wet, cookies
                        op uw apparaat opslaan als deze cookies strikt noodzakelijk zijn om de website te kunnen
                        gebruiken.
                        Voor andere
                        soort cookies is uw toestemming nodig. Wij raden aan om de cookies te accepteren in verband met
                        de
                        gebruiksvriendelijkheid van de website. Bezoekers van de website hebben een check in
                        mogelijkheid.</p>
                    <p id="c5714c75-7d98-404c-83c1-5b575bf4a491" className="">De cookies die Oogst.app gebruikt zijn
                        functionele
                        cookies:
                        deze cookies zorgen ervoor dat de website naar behoren werkt. Deze cookies hebben geen gevolgen
                        voor
                        de
                        persoonlijke levenssfeer zodat er geen toestemming gevraagd en verleend hoeft te worden. Met
                        deze
                        cookies wordt
                        bijvoorbeeld uw browserinstellingen opgeslagen zodat onze website het beste bekeken kan worden,
                        of
                        dat de
                        website bereikbaar blijft (load-balancing) maar ook cookies die ervoor zorgen dat er geen andere
                        cookies mogen
                        worden geplaats (no-follow).</p>
                    <p id="37db3dcb-b5b3-4733-b266-fbf6097ca53a" className="">Op de website van Oogst.app worden tevens
                        cookies
                        van Google
                        geplaatst ten behoeve van Google Analytics. Wij houden geen informatie bij van hetgeen u op
                        internet
                        doet.
                        Google Analytics is mogelijk verplicht op grond van geldende wet- en regelgeving inzage te geven
                        in
                        deze
                        gegevens Dit heeft tot gevolg dat Oogst.app informatie niet kan koppelen aan een natuurlijke
                        persoon.</p>
                    <p id="2b7c5ea5-799e-4d83-8765-0e189baddfd2" className="">Daarnaast maakt Oogst.app gebruik van
                        tracking
                        cookies. Met
                        tracking cookies wordt uw bezoekersgedrag op de website bijgehouden, op basis waarvan een
                        profiel
                        wordt
                        opgebouwd. Dit profiel is niet gekoppeld aan uw naam, adres, e-mailadres e.d. en is uitsluitend
                        bedoeld voor het
                        afstemmen van advertenties op uw profiel zodat deze zo relevant mogelijk zijn.</p>
                    <p id="4f2751c2-da2a-4567-ba47-152bc96c3317" className="">Indien u hierover vragen heeft kunt u
                        contact
                        opnemen via
                        support@oogst.app</p>
                    <h1 id="55a56057-843d-434e-8731-887c51d9d2c5" className="">Gebruik Social Media</h1>
                    <p id="ee95c1a5-5bed-4897-989e-7c1b399a7ccb" className="">Oogst.app maakt gebruik van cookies van
                        derde
                        partijen om de
                        website te optimaliseren. Sommige cookies worden geplaatst door diensten van derden die op de
                        website worden
                        weergegeven. Met derden wordt bedoeld Google Analytics en Social Media (Instagram, Facebook,
                        Twitter
                        en
                        Youtube). Op het gebruik van cookies van andere bedrijven (derden) is het privacy- en
                        cookiebeleid
                        van het
                        betreffende bedrijf van toepassing. Wanneer u op de website de Social Media button aanklikt,
                        wordt
                        een Social
                        Media cookie geplaatst. Voor de cookies van Social Media partijen en de data en/of
                        persoonsgegevens
                        die zij
                        hiermee verzamelen, verwijst Oogst.app u naar de privacy- en cookieverklaringen van deze
                        partijen.</p>
                    <p id="5763e3dd-f3bb-4fd0-aa8e-7544e0476f19" className="">Browserinstellingen<br/>Als u niet wilt
                        dat
                        websites cookies
                        plaatsen op uw apparaat waarmee u de website bekijkt, kunt u uw browserinstellingen aanpassen.
                        Voordat een
                        cookie geplaatst wordt, krijgt u een waarschuwing en dient u toestemming te geven voor de
                        cookie.
                        Doet u dat
                        niet, kan dat bijvoorbeeld tot gevolg hebben dat de website minder goed werkt. U kunt de
                        instellingen van uw
                        browser aanpassen zodat uw browser alle cookies en ook de cookies van derde(n) weigert. Ook kunt
                        u
                        geplaatste
                        cookies verwijderen. Hiervoor moet u de instellingen van uw browser aanpassen via voorkeuren en
                        vervolgens kunt
                        u de privacy instellingen aanpassen.<br/></p>
                    <p id="5948e1e8-d699-4408-b87b-612a271cccdc" className="">Deze privacyverklaring is niet van
                        toepassing op
                        websites van
                        derden die door middel van links met deze website zijn verbonden. Wij kunnen niet garanderen dat
                        deze derden op
                        een betrouwbare of veilige manier met uw persoonsgegevens omgaan. Wij raden u aan de
                        privacyverklaring van deze
                        websites te lezen alvorens van deze websites gebruik te maken.</p>
                    <h1 id="583f65f3-f340-4aae-be8a-d8b9a0309433" className="">Rechten van betrokkenen</h1>
                    <p id="4ce2c756-5d63-4716-9ced-26e98b8ae0b9" className="">Als betrokkene heeft u de volgende
                        rechten:<br/>–
                        Recht op
                        inzage;<br/>Als betrokkene heeft u het recht om uitsluitsel te krijgen over het al dan niet
                        verwerken van uw
                        persoonsgegevens en, wanneer dat het geval is, om inzage te verkrijgen met betrekking tot de
                        verwerking daarvan.<br/>–
                        Recht op rectificatie;<br/>U heeft het recht om rectificatie en aanvulling van onjuiste gegevens
                        te
                        verkrijgen.<br/>– Recht op gegevenswissing.<br/>Zonder onredelijke vertraging dient een
                        betrokkene
                        wissing van
                        hem betreffende persoonsgegevens te verkrijgen.<br/>– Recht op beperking van de verwerking;<br/>Als
                        betrokkene
                        heeft u het recht op beperking van de verwerking van uw persoonsgegevens. Neem hiervoor contact
                        op
                        met
                        Oogst.app.<br/>– Recht op overdraagbaarheid van gegevens;<br/>Een betrokkene heeft het recht om
                        de
                        hem
                        betreffende persoonsgegevens die hij verstrekt heeft aan Oogst.app , in een gestructureerde,
                        gangbare en
                        machineleesbare vorm te verkrijgen, en deze gegevens tevens aan Oogst.app over te dragen zonder
                        gehinderd te
                        worden door de verwerkingsverantwoordelijke aan wie ze verstrekt waren.<br/>– Recht van
                        bezwaar;<br/>De
                        betrokkene heeft te allen tijde het recht om vanwege met zijn specifieke situatie verband
                        houdende
                        redenen
                        bezwaar te maken tegen de verwerking van hem betreffende persoonsgegevens met inbegrip van
                        profilering op basis
                        van die bepalingen. Oogst.app staakt de verwerking van de persoonsgegevens tenzij er sprake is
                        van
                        dwingende
                        gerechtvaardigde gronden voor de verwerking die zwaarder wegen dan de belangen, vrijheden en
                        rechten
                        van
                        betrokkene die verband houden met de uitoefening van, instelling of onderbouwing van een
                        rechtsvordering.<br/>
                    </p>
                    <h1 id="16be4ec1-5a7d-42f0-92c7-f90976212e1a" className="">Klacht</h1>
                    <p id="536d7725-556d-462e-a1ce-95eab9044d61" className="">Indien u een klacht heeft over de wijze
                        waarop
                        Oogst.app met
                        uw persoonsgegevens omgaat, of een van bovengenoemde rechten wenst uit te oefenen, kunt u
                        contact
                        opnemen via de
                        website, per e-mail <a href="mailto:support@oogst.app">support@oogst.app</a> Om er zeker van te
                        zijn
                        dat u een
                        recht wenst uit te oefenen verzoekt Oogst.app u om een kopie van uw identiteitsbewijs mee te
                        sturen.
                        U kunt
                        hierbij uw pasfoto en MRZ (strook met nummers onderaan) zwart maken ter bescherming van uw
                        privacy.
                        Oogst.app
                        zal zo spoedig mogelijk, doch uiterlijk binnen 4 weken op uw verzoek reageren. Tevens kunt u een
                        klacht indienen
                        bij de Autoriteit Persoonsgegevens. Dit is de bevoegde handhavingsinstantie. U kunt hiervoor
                        contact
                        opnemen via
                        deze link: <a
                            href="https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons">https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons</a>.
                    </p>
                    <p id="b968fc57-1201-45ea-8944-92c9487598a6" className="">Wijzigingen Privacy Statement<br/>Oogst.app
                        kan te
                        allen tijde
                        de privacyverklaring aanpassen. Op de website staat de meest recente versie gepubliceerd. Houd
                        daarom altijd de
                        website in de gaten voor de meest recente versie. Als het nieuwe privacy statement gevolgen
                        heeft
                        voor de wijze
                        waarop wij reeds verzamelde gegevens met betrekking tot u verwerken, dan brengen wij u per
                        e-mail
                        daarvan op de
                        hoogte.<br/></p>
                    <p id="59ba0af8-a17c-42c0-80d0-4a6bca953e56" className="">Deze versie is voor het laatst vastgesteld
                        op 20
                        agususts
                        2024.</p></div>

            </Card>
        </div>
    );
}
